import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseColumnComponent } from '../../../../record/services/base-column-component';
import { ReportRow } from '../../../entities/report-row.entity';

@Component({
    standalone: false,
    selector: 'digihaven-report-naam-cell',
    templateUrl: './report-naam-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportNaamCellComponent extends BaseColumnComponent<ReportRow> {}
